import React, { useState } from "react";
import api from "../api";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { Ajutor } from "../../pages/Sistem/Ajutor";
import { useAuth } from "../AuthContext";
import { AjutorButton } from "../AjutorButton";

const inp = {
  border: "1px solid #000", padding: "6px 8px", fontFamily: "Arial",
  fontSize: 12, color: "#000", background: "#fff", outline: "none",
};

export default function ErpYvola() {
  const { user } = useAuth();
  const [personName, setPersonName] = useState(user?.name || "");
  const [phone, setPhone] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const appName = "ERP YVOLA";

  const submit = async () => {
    if (personName.trim().length < 2) { toast.error("Introdu numele complet"); return; }
    if (phone.trim().length < 4) { toast.error("Introdu un numar de telefon valid"); return; }
    setSending(true);
    try {
      const resp = await api.post("/erp-access/request", { person_name: personName.trim(), phone: phone.trim() });
      setSent(true);
      const { sso_token, erp_url } = resp?.data || {};
      const base = erp_url || "https://erp.yvola.eu";
      toast.success("Solicitarea a fost trimisa. Se deschide ERP YVOLA...");
      if (sso_token) {
        window.location.href = `${base}/dashboard?sso=${encodeURIComponent(sso_token)}`;
      } else {
        window.location.href = `${base}/dashboard`;
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Eroare la trimitere");
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="erp-yvola-page" style={{ fontFamily: "Arial", fontSize: 12, color: "#000", background: "#fff" }}>
      <AjutorButton file="ajutor_erp_yvola.pdf" />
      <div data-testid="erp-access-request-box" style={{ border: "1px solid #000", padding: 16, margin: "0 auto 16px", maxWidth: 1152, background: "#fff" }}>
        {sent ? (
          <div data-testid="erp-access-request-sent" style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
            <CheckCircle2 className="w-5 h-5" style={{ color: "#000" }} />
            <div>Solicitarea a fost trimisa. Veti fi contactat la numarul {phone}.</div>
          </div>
        ) : (
          <div>
            <div style={{ fontWeight: "bold", marginBottom: 10 }}>
              Doresc acces la aceasta aplicatie{appName ? ` (${appName})` : ""}. Sunati-ma la numarul de mai jos.
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center" }}>
              <input
                data-testid="erp-access-name-input"
                value={personName}
                onChange={(e) => setPersonName(e.target.value)}
                placeholder="Nume si prenume (ex: Popescu Ion)"
                style={{ ...inp, minWidth: 240 }}
              />
              <input
                data-testid="erp-access-phone-input"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Numar de telefon"
                style={{ ...inp, minWidth: 180 }}
              />
              <button
                data-testid="erp-access-submit-button"
                onClick={submit}
                disabled={sending}
                style={{ border: "1px solid #000", background: "#000", color: "#fff", padding: "6px 16px", fontFamily: "Arial", fontSize: 12, cursor: "pointer", opacity: sending ? 0.6 : 1 }}
              >
                {sending ? "Se trimite..." : "Trimite"}
              </button>
            </div>
          </div>
        )}
      </div>
      <Ajutor />
    </div>
  );
}
